module.exports = "<button mat-icon-button [fxHide]=\"true\" [fxHide.gt-xs]=\"false\" (click)=\"toggleFullscreen()\">\r\n    <mat-icon *ngIf=\"!isFullscreen\">fullscreen</mat-icon>\r\n    <mat-icon *ngIf=\"isFullscreen\">fullscreen_exit</mat-icon>\r\n</button>"


//////////////////
// WEBPACK FOOTER
// E:/sree/New folder (3)/cdk-material-v2/src/app/core/fullscreen/fullscreen.component.html
// module id = ../../../../../src/app/core/fullscreen/fullscreen.component.html
// module chunks = main